import React, { useState } from 'react';
import styles from './FAQ.module.css';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  
  const faqs = [
    {
      question: "Что такое система 9 Дворцов и как она работает?",
      answer: "Система 9 Дворцов - это древняя китайская метафизическая система, которая раньше была доступна только императорам. Она основана на расчете персональной энергетической карты по дате, времени и месту рождения и показывает взаимодействие вашей энергии с энергиями года. В отличие от Ба Цзы, система 9 Дворцов менее распространена и считается более эксклюзивной. Наш прогноз использует систему 9 Дворцов в сочетании с элементами Ба Цзы для более точного расчета."
    },
    {
      question: "Чем прогноз 9 Дворцов отличается от обычного гороскопа?",
      answer: "Обычный гороскоп дает общие рекомендации для всех представителей знака зодиака. Наш прогноз рассчитывается индивидуально по вашей карте рождения (дата, время, место) и учитывает взаимодействие вашей энергии с энергиями 2026 года. Вы получаете не общие советы, а конкретные даты, направления, часы и техники, персонализированные под вас. Это практический инструмент для планирования года, а не просто предсказание."
    },
    {
      question: "Какая информация нужна для расчета прогноза?",
      answer: "Для расчета персонального прогноза нам нужна ваша дата рождения (день, месяц, год), время рождения (желательно точное, но можно указать примерное или отметить \"не знаю\") и место рождения (город, страна). Чем точнее данные, тем детальнее получится прогноз, но даже без точного времени рождения мы сможем сделать расчет."
    },
    {
      question: "Сколько времени занимает расчет прогноза?",
      answer: "Персональный расчет вашего прогноза занимает 21 день. Это потому, что каждый прогноз рассчитывается индивидуально по вашей карте рождения с учетом всех нюансов 2026 года. Мы не используем шаблоны - каждый прогноз создается специально для вас. Конкуренты делают похожий расчет за 45 дней - мы в 2 раза быстрее."
    },
    {
      question: "Что такое денежные часы и как их использовать?",
      answer: "Денежные часы - это техника работы с денежной энергией через время. Каждый день имеет определенные часы, когда денежная энергия наиболее активна. В вашем прогнозе будет указано, в какое время суток (например, с 9:00 до 11:00 или с 15:00 до 17:00) вам нужно совершать финансовые операции: переводить деньги, оплачивать счета, получать платежи, делать покупки. Регулярное использование денежных часов в течение года создает сильную связь с денежной энергией."
    },
    {
      question: "Что такое грабитель богатства и как его использовать?",
      answer: "Грабитель богатства - это особая техника работы с определенными днями года, когда денежная энергия особенно сильна. В вашем прогнозе будут указаны конкретные даты \"грабителя богатства\" на весь 2026 год. В эти дни особенно эффективно совершать крупные покупки, делать финансовые вложения, открывать депозиты или инвестиционные счета, заключать важные финансовые сделки."
    },
    {
      question: "Нужен ли мне прогноз, если у меня все хорошо?",
      answer: "Даже если все хорошо, прогноз поможет вам сохранить успех и не потерять его из-за ошибок, оптимизировать процессы и ускорить достижение целей, узнать благоприятные периоды для новых начинаний, планировать год более осознанно. Предотвратить проблемы дешевле, чем решать их. Особенно важно планирование в 2026 году - переходном периоде, который влияет на следующие 60+ лет."
    },
    {
      question: "Как понять, нужен ли мне прогноз на 2026 год?",
      answer: "Прогноз особенно полезен, если вы планируете важные изменения в жизни (новый бизнес, переезд, крупные покупки), хотите избежать ошибок и выгорания, нуждаетесь в инструментах для финансового планирования, хотите планировать год более осознанно, понимаете важность 2026 года (переходный период). Если вы чувствуете, что вам нужна система для принятия решений, а не действовать наугад - прогноз вам подойдет."
    },
    {
      question: "Почему 2026 год особенный для планирования?",
      answer: "2026 год - это Год Огненной Лошади, переходный период (9-й период в 180-летнем цикле). Влияние этого года сохранится на следующие 60+ лет. Решения, которые вы примете в 2026 году, их последствия будут влиять на вашу жизнь на протяжении десятилетий вперед. В такие переходные периоды особенно важно действовать правильно и в нужное время."
    },
    {
      question: "Как использовать прогноз на практике?",
      answer: "Прогноз - это практический инструмент. Открывайте его каждое утро, планируйте день по рекомендациям, используйте денежные часы для финансовых операций, отмечайте дни грабителя богатства в календаре, избегайте опасных направлений в указанные месяцы, бережно относитесь к себе в энергосберегающие месяцы, планируйте важные проекты на благоприятные дни. Все инструменты подробно описаны в прогнозе с инструкциями."
    }
  ];
  
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  
  return (
    <section className={styles.faq}>
      <div className={styles.container}>
        <h2 className={styles.heading}>Часто задаваемые вопросы о прогнозе по 9 Дворцам</h2>
        <div className={styles.faqList}>
          {faqs.map((faq, index) => (
            <div key={index} className={styles.faqItem}>
              <button
                className={styles.question}
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                {faq.question}
                <span className={styles.icon}>{openIndex === index ? '−' : '+'}</span>
              </button>
              {openIndex === index && (
                <div className={styles.answer}>
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;

